/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from "react";
import { useMemo } from "react";

export interface AppRoutePolicy {
  /**
   * Suppresses the shell-level Quick Add action in AppLayout.
   */
  suppressTopBarQuickAdd?: boolean;
  /**
   * Explicitly force shell-level Quick Add visibility.
   */
  showTopBarQuickAdd?: boolean;
  /**
   * Route-level timeout hint in milliseconds for data-dependent wrappers.
   */
  timeoutMs?: number;
  /**
   * Controls route error UI strategy.
   */
  errorRecovery?: "default" | "none";
  /**
   * Explicit exemption when route-level error UI is intentionally delegated elsewhere.
   */
  exemptFromRouteErrorBoundary?: boolean;
  /**
   * Free-form route recovery notes for diagnostics.
   */
  routeRecoveryHint?: string;
}

const DEFAULT_ROUTE_POLICY: AppRoutePolicy = {
  showTopBarQuickAdd: true,
  errorRecovery: "default",
};

const AppRoutePolicyContext = createContext<AppRoutePolicy>(DEFAULT_ROUTE_POLICY);

export function AppRoutePolicyProvider({
  policy,
  children,
}: {
  policy: AppRoutePolicy | undefined;
  children: React.ReactNode;
}) {
  const resolvedPolicy = useMemo(
    () => ({ ...DEFAULT_ROUTE_POLICY, ...(policy ?? {}) }),
    [policy],
  );

  return <AppRoutePolicyContext.Provider value={resolvedPolicy}>{children}</AppRoutePolicyContext.Provider>;
}

export function useAppRoutePolicy() {
  return useContext(AppRoutePolicyContext);
}

export const routePolicyDefaults = DEFAULT_ROUTE_POLICY;